import Calendar from '../components/single-show-calendar.svelte'
import Content from '../components/icon-switching-content/ss-wrap.svelte'

export default {
	init() {
		let $contentWrap = $('#sc_inner')
		let $calendar = $('#calendar')

		if ($contentWrap.length) {
			new Content({
				target: $contentWrap[0],
				props: $contentWrap.data(),
			})
		}

		if ($calendar.length) {
			new Calendar({
				target: $calendar[0],
				props: $calendar.data(),
			})
		}
	},
}

